import { useHistory, useParams } from 'react-router-dom';
import { updateProfile } from 'flow/actions/profile-actions';
import Page from 'flow/components/Setting/Page';
import CallRecordingSelection from 'flow/components/settings/call-recording/CallRecordingSelection';
import useProfiles from 'flow/hooks/useProfiles';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { CallRecordingSettings, SettingsType } from 'flow/types/CallRecording';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { getUpdatedProfileDTO } from 'flow/utils/call-recording-monitoring-utils';
import { generatePath } from 'flow/utils/router-utils';
import { useState } from 'react';

const CallRecordingPerProfileSettings = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, profileKey, settingType } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
        settingType: SettingsType;
    }>();

    const { getProfile } = useProfiles(extensionKey);
    const profile = getProfile(profileKey);

    const [storingOption, setStoringOption] = useState(null);

    if (!profile) {
        return null;
    }

    const handleOptionSelected = (value: CallRecordingSettings) => {
        setStoringOption(value);
        const profileDTO = getUpdatedProfileDTO(profile, value, settingType);
        dispatch(
            updateProfile(extensionKey, profileDTO, () =>
                setStoringOption(null),
            ),
        );
    };

    return (
        <Page
            header={'settings.call_recording'}
            onClickBack={() =>
                history.push({
                    pathname: generatePath(
                        routes[
                            'settings.call-recording-and-monitoring.settings'
                        ],
                        {
                            extensionKey,
                            settingType,
                        },
                    ),
                    state: { editPerProfile: true },
                })
            }
        >
            <CallRecordingSelection
                profile={profile}
                onSelected={handleOptionSelected}
                settingsType={settingType}
                storingOption={storingOption}
            />
        </Page>
    );
};

export default CallRecordingPerProfileSettings;
